module.exports = __webpack_public_path__ + "img/loaderbar.0cf71048.gif";